var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { getAssets, getDisplayAssets, hasVaultVersion, isPutVault, VaultList, VaultVersionList, } from "../../constants/constants";
import sizes from "../../designSystem/sizes";
import { useLatestAPYs } from "../../hooks/useLatestAPY";
import useScreenSize from "../../hooks/useScreenSize";
import useVaultAccounts from "../../hooks/useVaultAccounts";
import { useVaultsData } from "../../hooks/web3DataContext";
import DesktopProductCatalogue from "./DesktopProductCatalogue";
import MobileProductCatalogue from "./MobileProductCatalogue";
import { VaultReleaseOrder, VaultSortByList, } from "./types";
import useWeb3Wallet from "../../hooks/useWeb3Wallet";
import { getIntegralAsset } from "../../utils/asset";
import { useChain } from "../../hooks/chainContext";
var ProductCatalogue = function (_a) {
    var vaultIcon = _a.vaultIcon, variant = _a.variant, onVaultPress = _a.onVaultPress;
    var chain = useChain()[0];
    var chainId = useWeb3Wallet().chainId;
    var width = useScreenSize().width;
    var _b = useState(""), filterVaults = _b[0], setFilterVaults = _b[1];
    var _c = useState([]), filterStrategies = _c[0], setFilterStrategies = _c[1];
    var _d = useState([]), filterAssets = _d[0], setFilterAssets = _d[1];
    var _e = useState(VaultSortByList[0]), sort = _e[0], setSort = _e[1];
    var yieldsData = useLatestAPYs();
    var _f = useVaultsData(), v1VaultsData = _f.data, v1VaultsDataLoading = _f.loading;
    var vaultAccounts = useVaultAccounts("all").vaultAccounts;
    var _g = useState({}), userSelectedVaultsVersion = _g[0], setUserSelectedVaultsVersion = _g[1];
    var vaultsDisplayVersion = useMemo(function () {
        return Object.fromEntries(VaultList.map(function (vaultOption) {
            // User had selected their desired version
            if (userSelectedVaultsVersion[vaultOption]) {
                return [vaultOption, userSelectedVaultsVersion[vaultOption]];
            }
            var availableVaultVersions = VaultVersionList.filter(function (version) {
                return hasVaultVersion(vaultOption, version);
            });
            // If vault only has one available version
            if (availableVaultVersions.length === 1) {
                return [vaultOption, availableVaultVersions[0]];
            }
            for (var i = 0; i < availableVaultVersions.length; i++) {
                switch (availableVaultVersions[i]) {
                    case "v1":
                        /**
                         * We check for V1 vault if it had been disabled
                         * If we are still loading data and default vault version is v1,
                         * then we proceed to show v1
                         * It it had been disabled, we show other available vault version instead
                         */
                        if (v1VaultsDataLoading ||
                            !v1VaultsData[vaultOption].vaultLimit.isZero()) {
                            return [vaultOption, "v1"];
                        }
                        break;
                    case "v2":
                        return [vaultOption, "v2"];
                }
            }
            return [vaultOption, VaultVersionList[0]];
        }));
    }, [userSelectedVaultsVersion, v1VaultsData, v1VaultsDataLoading]);
    var setVaultDisplayVersion = useCallback(function (vaultOption, vaultVersion) {
        setUserSelectedVaultsVersion(function (userSelectedVaultsVersion) {
            var _a;
            return (__assign(__assign({}, userSelectedVaultsVersion), (_a = {}, _a[vaultOption] = vaultVersion, _a)));
        });
    }, []);
    var filteredProducts = useMemo(function () {
        var filteredList = VaultList.filter(function (vault) {
            // if (vault === 'rBUSD-AVAX-P-THETA') {
            //   return false;
            // }
            // if (
            //   chain !== Chains.NotSelected &&
            //   (getChainByVaultOption(vault) !== chain ||
            //     (chainId && VaultAddressMap[vault].chainId !== chainId))
            // ) {
            // console.group("Vault filtered 1 " + vault)
            // console.log('chainId && VaultAddressMap[vault].chainId !== chainId:', chainId && VaultAddressMap[vault].chainId !== chainId)
            // console.log('getChainByVaultOption(vault) !== chain:', getChainByVaultOption(vault) !== chain)
            // console.log('getChainByVaultOption(vault):', getChainByVaultOption(vault))
            // console.log('chain:', chain)
            // console.log('chainId:', chainId)
            // console.log('VaultAddressMap[vault].chainId:', VaultAddressMap[vault].chainId)
            // console.groupEnd()
            // console.log('Vault filtered 1:', vault)
            //   return false;
            // }
            if (filterVaults && vault.indexOf(filterVaults) < 0) {
                return false;
            }
            // console.log("filterStrategies:", filterStrategies)
            // Filter for strategies
            if (filterStrategies.length &&
                !filterStrategies.includes(isPutVault(vault) ? "Put Selling" : "Covered Call")) {
                // console.log('Vault filtered 2:', vault)
                return false;
            }
            // Filter for assets
            var asset = getAssets(vault);
            if (filterAssets.length &&
                !filterAssets.includes(asset) &&
                !filterAssets.includes(getDisplayAssets(vault)) &&
                !filterAssets.includes(getIntegralAsset(asset))) {
                // console.log('Vault filtered 3:', vault)
                return false;
            }
            return true;
        });
        // console.log('filteredList:', filteredList)
        switch (sort) {
            case "Newest First":
                filteredList.sort(function (a, b) {
                    return VaultReleaseOrder.indexOf(a) < VaultReleaseOrder.indexOf(b) ? 1 : -1;
                });
                break;
            case "Oldest First":
                filteredList.sort(function (a, b) {
                    return VaultReleaseOrder.indexOf(a) > VaultReleaseOrder.indexOf(b) ? 1 : -1;
                });
                break;
            case "Yield: High To Low":
                filteredList.sort(function (a, b) {
                    return yieldsData.res[vaultsDisplayVersion[a]][a] <
                        yieldsData.res[vaultsDisplayVersion[b]][b]
                        ? 1
                        : -1;
                });
                break;
            case "Yield: Low To High":
                filteredList.sort(function (a, b) {
                    return yieldsData.res[vaultsDisplayVersion[a]][a] >
                        yieldsData.res[vaultsDisplayVersion[b]][b]
                        ? 1
                        : -1;
                });
                break;
        }
        return filteredList;
    }, [
        chain,
        chainId,
        filterAssets,
        filterStrategies,
        sort,
        vaultsDisplayVersion,
        yieldsData,
    ]);
    return width > sizes.md ? (_jsx(DesktopProductCatalogue, { variant: variant, vaultIcon: vaultIcon, onVaultPress: onVaultPress, filterVaults: filterVaults, filterStrategies: filterStrategies, filterAssets: filterAssets, sort: sort, setFilterVaults: setFilterVaults, setFilterStrategies: setFilterStrategies, setFilterAssets: setFilterAssets, setSort: setSort, filteredProducts: filteredProducts, vaultAccounts: vaultAccounts, vaultsDisplayVersion: vaultsDisplayVersion, setVaultDisplayVersion: setVaultDisplayVersion }, void 0)) : (_jsx(MobileProductCatalogue, { variant: variant, onVaultPress: onVaultPress, filterStrategies: filterStrategies, filterAssets: filterAssets, sort: sort, setFilterStrategies: setFilterStrategies, setFilterAssets: setFilterAssets, setSort: setSort, filteredProducts: filteredProducts, vaultAccounts: vaultAccounts, vaultsDisplayVersion: vaultsDisplayVersion, setVaultDisplayVersion: setVaultDisplayVersion }, void 0));
};
export default ProductCatalogue;
//# sourceMappingURL=ProductCatalogue.js.map